import { Identifier } from '@okletsplay/core';
import { UserPaymentQuotasDto } from 'app/interfaces/dto';
import { apiRequestCall } from 'app/services/api';
import { ApiResource } from 'app/services/api/enums';
import { CancelToken } from 'axios';

export const getUserPaymentQuotas = ({
  userId,
  cancelToken,
}: {
  userId: Identifier;
  cancelToken: CancelToken;
}) => {
  return apiRequestCall<UserPaymentQuotasDto>({
    params: {
      method: 'GET',
      resource: ApiResource.Admin,
      urlPrefix: `users/${userId}/quotas`,
      cancelToken,
    },
  });
};
